import { toast } from 'react-toastify';

export const autocompleteListener = (google, input, callback) => {
  const autocomplete = new google.maps.places.Autocomplete(
    input.current,
    {
      types: ['geocode'],
      componentRestrictions: {country: ["us", "pr"]}
    }
  );

  autocomplete.setFields([
    'formatted_address',
    'geometry'
  ]);

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();

    if (!place.geometry) {
      toast.warning('Please select an address from the dropdown.', {position: 'top-center'});
    } else {
      const { lat, lng } =  place.geometry.location;
      const latLng = new google.maps.LatLng(lat(), lng());

      callback({
        ...place,
        lat: lat(),
        lng: lng(),
        latLng
      });
    }
  });
};
